// ** Table Import
import Table from './Table'

// ** Styles
import '@src/assets/scss/ntts-tokens.css'
import '@src/assets/scss/ntts-page.scss'
import '@src/assets/scss/ntts-dialog.scss'
import './mentorMaster.scss'

const MentorMaster = () => {
  return (
    <div className="ntts-page">
      <Table />
    </div>
  )
}

export default MentorMaster
